import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const WeWantYouLookBest = lazyWithPreload(
  () => import('./WeWantYouLookBest'),
)
export const WeWantYouLookBest2 = lazyWithPreload(
  () => import('./WeWantYouLookBest2'),
)
